<!--
 * @Description: 原物料结算
 * @Autor: wangwangwang
 * @Date: 2021-03-25 09:21:19
 * @LastEditors: hexy 913752270@qq.com
 * @LastEditTime: 2026-07-03 09:26:07
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <!-- 导航 -->
        <div class="tabtop">
          <div v-for="(item, index) in navlist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
            <div v-if="currenindex !== index + 1 && currenindex !== index + 2 && index !== 2" class="hr"></div>
          </div>
        </div>
        <!-- 搜索条件 -->
        <div>
          <!-- <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div> -->
          <el-collapse-transition>
            <div v-show="showCardNav" style="padding-top: 18px">
              <el-form v-if="currenindex !== 3" :inline="true" label-width="110px">
                <el-form-item>
                  <span slot="label">结算时间段</span>
                  <el-date-picker v-model="datePicker" style="height: 36px" type="datetimerange" unlink-panels
                    align="right" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <span slot="label">供应商</span>
                  <div v-if="currenindex == 1 || currenindex == 2" style="width: 240px; height: 36px; display: flex">
                    <div :title="searchText"
                      style="width: 220px; padding: 0 10px; border-bottom: 1px solid #bbb; margin-right: 5px"
                      class="ellipsis">{{ searchText }}</div>
                    <el-button class="bottom_all_two" @click="search = true">选择</el-button>
                    <!-- <el-button class="bottom_all_two" @click="getsearchData(), (search = true)">选择</el-button> -->
                  </div>
                  <!-- <el-select v-if="currenindex == 2" v-model="tableParam.contractId" placeholder="请选择">
                    <el-option v-for="(item, index) in contractId" :key="index" :label="item.supplier" :value="item.supplierId"></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item v-if="currenindex == 1 || currenindex == 2">
                  <span slot="label">原物料类型</span>
                  <el-select ref="rawType" v-model="tableParam.rawTypeId" placeholder="请选择" style="width: 130px" @change="
                    $nextTick(() => {
                      tableParam.rawType = $refs.rawType.selectedLabel;
                    })
                    ">
                    <el-option v-for="item in typelist" :key="item.id" :label="item.itemName"
                      :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all"
                    @click="(tableParam.page = 1), pagesgettableData()">查 询</el-button>
                  <el-button v-if="currenindex != 3" size="medium" class="bottom_all_two" style="margin-left: 12px"
                    @click="init()">重 置</el-button>
                  <el-button v-if="currenindex == 1 && ButtonList.findIndex(res => res.buttonValue == 'SHENGCJSD') !== -1"
                    style="margin-left: 12px" size="small" class="bottom_three"
                    :disabled="generate.logisticsList.length == 0" @click="statements">
                    生成结算单
                  </el-button>
                </el-form-item>
              </el-form>
              <el-form v-if="currenindex == 3" :inline="true" label-width="110px">
                <el-form-item>
                  <span slot="label">结算单编号</span>
                  <el-input v-model="tableParam.statementNo" placeholder="请输入" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <span slot="label">供应商</span>
                  <el-select v-model="tableParam.supplierId" placeholder="请选择" filterable>
                    <el-option v-for="(item, index) in searchData" :key="index" :label="item.supplier"
                      :value="item.supplierId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button icon="el-icon-search" size="medium" class="bottom_all"
                    @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                  <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重
                    置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <!-- <div v-show="currenindex == 1" class="card_nav">
              <div>
              </div>
              <div></div>
            </div> -->
            <div v-loading="tableLoading" class="card_info">
              <el-table ref="table" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                border stripe style="width: 100%" :height="screenHeight - 390" :data="tableData" tooltip-effect="dark"
                show-summary :summary-method="getSummaries" @selection-change="pageshandleSelectionChange">
                <el-table-column v-if="currenindex == 1" align="center" type="selection"></el-table-column>
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                    :min-width="item.width">
                    <template slot-scope="scope">
                      <span v-if="item.label == '结算时间段'"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </span>
                      <div v-else-if="item.label == '结算单编号'" class="table_link" @click="show(scope.row)">
                        {{ scope.row[item.prop] }}
                      </div>
                      <span v-else-if="item.label == '审核状态'">
                        <span v-if="scope.row.auditStatus == 1">待提交</span>
                        <span v-else-if="scope.row.auditStatus == 2">审核中</span>
                        <span v-else-if="scope.row.auditStatus == 3">通过</span>
                        <span v-else-if="scope.row.auditStatus == 4">未通过</span>
                      </span>
                      <span v-else-if="item.label == '集中供气'">
                        <span v-if="scope.row.supplyGas == 1">是</span>
                        <span v-else-if="scope.row.supplyGas == 0">否</span>
                      </span>
                      <span v-else-if="item.label == '操作'">
                        <el-button
                          v-if="scope.row.auditStatus == 3 && (scope.row.supplierConfirm == 0 || scope.row.supplierConfirm == 1)"
                          size="mini" class="bottom_all_two" @click="userSubmit(scope.row)"> 发送 </el-button>
                        <el-button v-if="scope.row.auditStatus == 1" size="mini" class="bottom_all_two"
                          @click="$router.push({ name: 'sign_material', query: { id: scope.row.statementNo, type: 1 } })">提交审核</el-button>
                        <el-button size="mini" class="bottom_all_two" @click="dockSend(scope.row)"> 推送 </el-button>
                      </span>
                      <span v-else-if="item.label == '供应商确认'">
                        <span v-if="scope.row.supplierConfirm == 0">未发送</span>
                        <span v-else-if="scope.row.supplierConfirm == 1">待查看</span>
                        <span v-else-if="scope.row.supplierConfirm == 2">通过</span>
                        <!-- <span v-else-if="scope.row.supplierConfirm==3">拒绝</span> -->
                      </span>
                      <span v-else-if="item.label == '附件'">
                        <span style="color: blue" @click="window.open(scope.row.picture)">{{ scope.row.picture }}</span>
                      </span>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000, '全部']" layout="prev,pager,slot,next,jumper"
            :total="total" @size-change="sizeChange"
            @current-change="currenindex == 3 ? pagesgettableData() : gettableData()">
            <el-select v-model="curElPage" class="pageSelectContainer" placeholder="请选择" @change="changeSizes">
              <el-option v-for="item in optionsPage" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
            @click="currenindex == 3 ? pagesgettableData() : gettableData()">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 选择供应商合同 -->
    <el-dialog v-dialogDrag :visible.sync="search" width="1000px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">选择供应商合同</span>
      <div class="search">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">供应商</span>
          <el-input v-model="supplierNameSearch" style="width: 240px" clearable placeholder="请输入"
            @keyup.enter.native="getsearchData()" />
        </span>
        <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="getsearchData()">查 询</el-button>
      </div>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="searchData" tooltip-effect="dark" @row-click="setradio">
          <el-table-column align="center" label="选择">
            <template slot-scope="scope">
              <el-radio :value="searchradio" :label="JSON.stringify(scope.row)">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column align="center" label="原物料合同编号" prop="contractNumber"></el-table-column>
          <el-table-column align="center" label="合同签订主体" prop="contractSigningSubject"></el-table-column>
          <el-table-column align="center" label="供应商单位" prop="supplierName"></el-table-column>
          <el-table-column align="center" label="是否包含运输">
            <template slot-scope="scope">
              {{ scope.row.isCarriage == 0 ? "否" : "是" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="原物料" prop="rawName"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="search = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitsearch">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 原物料-待结算-生成结算单 -->
    <el-dialog :visible.sync="billDeta" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">原物料结算单2</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">供应商：</span>{{ billDetails.supplier }}</span>
          <span><span class="text">合同签订主体：</span>{{ billDetails.contractSigningSubject }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails.startTime }}至{{ billDetails.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails.statementNo }}</span>
        </div>
        <div class="bill_title1">结算信息</div>
        <template v-for="(item, index) in billList">
          <div :key="index">
            <div class="bill_subtitle">
              <!-- <span><span class="text">协作单位：</span>{{ item.cooperativeUnit }}</span> -->
              <span><span class="text">结算物料：</span>{{ item.rawName }}</span>
            </div>
            <el-table :key="index" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
              border stripe style="width: 100%" :data="item.list" tooltip-effect="dark" show-summary :summary-method="(param) => getDetailSummaries(param, item.list)">
              <!-- <el-table-column label="协作单位" align="center" prop="cooperativeUnit" width="150" show-overflow-tooltip></el-table-column> -->
              <el-table-column label="时间段" align="center" width="175">
                <template slot-scope="scope"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </template>
              </el-table-column>
              <el-table-column label="站点" align="center" prop="receiveStation" width="120"></el-table-column>
              <el-table-column label="单价（元）" align="center" prop="unitPrice" width="120"></el-table-column>
              <el-table-column label="收货量" align="center" prop="receiveNum" width="120"></el-table-column>
              <el-table-column label="结算单价（元）" align="center" width="120"  prop="statementUnitPrice">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.statementUnitPrice" onchange="if(!value)value=0" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.statementUnitPrice = $regExp.checkNum(scope.row.statementUnitPrice)"
                    @blur="scope.row.statementUnitPrice = $regExp.blurCheckNum(scope.row.statementUnitPrice)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算量（吨）" align="center" width="120" prop="statementNum">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.statementNum" onchange="if(!value)value=0" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="应付金额（元）" align="center" prop="dealPrice" width="120">
                <template slot-scope="scope">
                  <!-- {{ (scope.row.dealPrice = Number($regExp.FloatMul(scope.row.statementUnitPrice || 0, scope.row.statementNum || 0)).toFixedRound(2)) }} -->
                  {{ (scope.row.dealPrice = decimal.mul(scope.row.statementUnitPrice || 0, scope.row.statementNum || 0))
                  }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额（元）" align="center" width="120" prop="increaseAmount">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" onchange="if(!value)value=0" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center" width="120" prop="realPay">
                <template slot-scope="scope">
                  {{ decimal.add(Number(scope.row.dealPrice || 0), Number(scope.row.increaseAmount || 0)) }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined(item.list) }}</div>
          </div>
        </template>
        <!-- 结算补差 -->
        <div v-show="senderDigList.length" class="bill_title">
          结算补差
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="selectSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择
          </el-button>
        </div>
        <template v-for="(item, index) in sendersList">
          <div :key="index + '2'">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border
              :show-header="index == 0" stripe style="width: 100%" :data="item.list" tooltip-effect="dark"
              :span-method="sendersSpanMethod" show-summary :summary-method="(param) => getCompensateSummaries(param, item.list)">
              <!-- <el-table-column label="开票单位" align="center" prop="cooperativeUnit"></el-table-column> -->
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
              <el-table-column label="补差日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
                </template>
              </el-table-column>
              <el-table-column label="补差数量" align="center" prop="compensateNum"> </el-table-column>
              <el-table-column label="补差单价（元）" align="center" prop="compensatePrice"> </el-table-column>
              <el-table-column label="补差金额（元）" align="center"  prop="compensateAmount">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.compensateAmount" placeholder="请输入" style="width: 100%" clearable
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined2(item, item.list) }}</div>
          </div>
        </template>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="deductionList" tooltip-effect="dark" show-summary :summary-method="getDeductionSummaries">
          <!-- <el-table-column label="协作单位" align="center">
            <template slot-scope="scope">
              <el-select ref="select1" v-model="scope.row.cooperativeUnitId" filterable style="width: 100%"
                placeholder="请选择协作单位">
                <el-option v-for="item in cooperativeUnitArr" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.cooperativeUnit = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column label="站点" align="center">
            <template slot-scope="scope">
              <el-select ref="station1" v-model="scope.row.stationId" style="width: 100%" placeholder="请选择站点">
                <el-option v-for="item in stations" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.station = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="原物料" align="center">
            <template slot-scope="scope">
              <el-select ref="rawId" v-model="scope.row.rawId" style="width: 100%" placeholder="请选择原物料">
                <el-option v-for="item in rawList" :key="item.rawId" :label="item.rawName" :value="item.rawId"
                  @click.native="scope.row.rawName = item.rawName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center">
            <template slot-scope="scope">
              <el-select ref="deductionType1" v-model="scope.row.deductionTypeId" style="width: 100%"
                placeholder="请选择调整类型">
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"
                  @click.native="scope.row.deductionType = item.itemName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="addOrReduce">
            <template slot-scope="scope">
              <el-select ref="addOrReduce" v-model="scope.row.addOrReduce" style="width: 100%" placeholder="请选择">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center" prop="deduction">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deduction" placeholder="请输入" style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.deduction = $regExp.checkNum(scope.row.deduction)"
                @blur="scope.row.deduction = $regExp.blurCheckNum(scope.row.deduction)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.influenceInvoice">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="是否进入当月结算" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isEnterSettle">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入" style="width: 100%" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 结算合计 -->
        <div class="bill_title">
          结算合计
          <el-button size="mini" class="bottom_all" style="margin-left: 24px" @click="addItem2()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="totalList" tooltip-effect="dark" show-summary :summary-method="getTotalSummaries">
          <!-- <el-table-column label="开票单位" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.localstatus" ref="cooperativeUnit2" v-model="scope.row.cooperativeUnitId"
                filterable style="width: 100%" placeholder="请选择" @change="
                  $nextTick(() => {
                    scope.row.cooperativeUnit = $refs.cooperativeUnit2.selectedLabel;
                  }),
                  check1('结算合计', scope.$index)
                  ">
                <el-option v-for="item in cooperativeUnit" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <div v-else>{{ scope.row.cooperativeUnit }}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="待结算金额（元）" align="center" prop="settlementAmount">
            <template slot-scope="scope">
              <div>{{ scope.row.localstatus ? "---" : scope.row.settlementAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="补差金额（元）" align="center" prop="compensateAmount">
            <template slot-scope="scope">
              <div>{{ scope.row.localstatus ? "---" : scope.row.compensateAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元）" align="center" prop="deduction">
            <template slot-scope="scope">
              <div>{{ scope.row.localstatus ? "---" : scope.row.deduction }}</div>
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="realPay">
            <template slot-scope="scope">
              <div>{{ scope.row.localstatus ? "---" : scope.row.realPay }}</div>
            </template>
          </el-table-column>
          <el-table-column label="开票金额（元）" align="center" prop="faceAdjustment">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faceAdjustment" placeholder="请输入" style="width: 100%"
                onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.faceAdjustment = $regExp.checkNum(scope.row.faceAdjustment)"
                @blur="scope.row.faceAdjustment = $regExp.blurCheckNum(scope.row.faceAdjustment)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button v-if="scope.row.localstatus" size="mini" class="bottom_two" @click="delItem2(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div>
          <el-button class="bottom_all_two" @click="combinedSubmit(1)">提交审核</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta = false">关 闭</el-button>
          <el-button class="bottom_all" style="margin-left: 24px" @click="combinedSubmit(0)">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- 原物料-结算单-编号-查看或修改 -->
    <el-dialog :visible.sync="billDeta1" width="1180px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">原物料结算单1</span>
      <div ref="html" style="padding: 10px 20px">
        <div class="bill_top">
          <span><span class="text">供应商：</span>{{ billDetails1.supplier }}</span>
          <span><span class="text">合同签订主体：</span>{{ billDetails1.contractSigningSubject }}</span>
          <span><span class="text">结算时间段：</span>{{ billDetails1.startTime }}至{{ billDetails1.endTime }}</span>
          <span><span class="text">结算单编号：</span>{{ billDetails1.statementNo }}</span>
        </div>
        <div class="bill_title1" style="padding-bottom: 15px">结算信息</div>
        <template v-for="(item, index) in billList">
          <div :key="index">
            <div class="bill_subtitle">
              <!-- <span><span class="text">协作单位：</span>{{ item.cooperativeUnit }}</span> -->
              <span><span class="text">结算物料：</span>{{ item.rawName }}</span>
            </div>
            <el-table :key="index+forceRefresh" :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
              border stripe style="width: 100%" :data="item.list" tooltip-effect="dark"
              show-summary :summary-method="(param) => getDetailSummaries(param, item.list)">
              <el-table-column label="时间段" align="center" width="175">
                <template slot-scope="scope"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </template>
              </el-table-column>
              <el-table-column label="站点" align="center" prop="receiveStation" width="120"></el-table-column>
              <el-table-column label="单价（元）" align="center" prop="unitPrice" width="120"></el-table-column>
              <el-table-column label="收货量" align="center" prop="receiveNum" width="120"></el-table-column>
              <el-table-column label="结算单价（元）" align="center" width="120" prop="statementUnitPrice">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.statementUnitPrice" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%" oninput="if(value > 999999999999 ){value = 999999999999}"
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.statementUnitPrice = $regExp.checkNum(scope.row.statementUnitPrice)"
                    @blur="scope.row.statementUnitPrice = $regExp.blurCheckNum(scope.row.statementUnitPrice)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算量（吨）" align="center" width="120" prop="statementNum">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.statementNum" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="应付金额（元）" align="center" prop="dealPrice" width="120">
                <template slot-scope="scope">
                  {{ (scope.row.dealPrice = decimal.mul(scope.row.statementUnitPrice || 0, scope.row.statementNum || 0))
                  }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额（元）" align="center" width="120" prop="increaseAmount">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.increaseAmount" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                    @input="scope.row.increaseAmount = $regExp.checkNum(scope.row.increaseAmount)"
                    @blur="scope.row.increaseAmount = $regExp.blurCheckNum(scope.row.increaseAmount)"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="结算金额（元）" align="center" width="120" prop="realPay">
                <template slot-scope="scope">
                  {{ scope.row.realPay = decimal.add(Number(scope.row.dealPrice || 0), Number(scope.row.increaseAmount ||
                    0)) }}
                </template>
              </el-table-column>
              <el-table-column label="增加金额备注" align="center" width="220">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.remark" :disabled="low.auditStatus != 1" placeholder="请输入"
                    style="width: 100%"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined(item.list) }}</div>
          </div>
        </template>
        <!-- 结算补差 -->
        <div v-show="sendersList.length || (low.auditStatus == 1 && senderDigList.length)" class="bill_title">
          结算补差
          <el-button v-show="low.auditStatus == 1" size="mini" class="bottom_all" style="margin-left: 24px"
            @click="selectSenders()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            选择
          </el-button>
        </div>
        <template v-for="(item, index) in sendersList">
          <div :key="index + '2'">
            <!-- <div class="bill_subtitle">
              <span><span class="text">协作单位：</span>{{ item.cooperativeUnit }}</span>
            </div> -->
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :show-header="index == 0" :data="item.list" tooltip-effect="dark"
              :span-method="sendersSpanMethod" show-summary :summary-method="(param) => getCompensateSummaries(param, item.list)">
              <!-- <el-table-column label="开票单位" align="center" prop="cooperativeUnit"></el-table-column> -->
              <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
              <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
              <el-table-column label="补差日期" align="center">
                <template slot-scope="scope">
                  {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
                </template>
              </el-table-column>
              <el-table-column label="补差数量" align="center" prop="compensateNum"> </el-table-column>
              <el-table-column label="补差单价（元）" align="center" prop="compensatePrice"> </el-table-column>
              <el-table-column label="补差金额（元）" align="center" prop="compensateAmount">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.compensateAmount" placeholder="请输入" :disabled="low.auditStatus != 1"
                    style="width: 100%" clearable
                    onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"></el-input>
                </template>
              </el-table-column>
            </el-table>
            <div style="border-top: 0px" class="combined">小计：{{ combined2(item, item.list) }}</div>
          </div>
        </template>
        <!-- 调整金额 -->
        <div class="bill_title">
          调整金额
          <el-button v-show="low.auditStatus == 1" size="mini" class="bottom_all" style="margin-left: 24px"
            @click="addItem1()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="deductionList" tooltip-effect="dark" show-summary :summary-method="getDeductionSummaries">
          <!-- <el-table-column label="协作单位" align="center" prop="cooperativeUnit">
            <template slot-scope="scope">
              <el-select ref="select2" v-model="scope.row.cooperativeUnitId" :disabled="low.auditStatus != 1" filterable
                style="width: 100%" placeholder="请选择协作单位">
                <el-option v-for="item in cooperativeUnitArr" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.cooperativeUnit = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column label="站点" align="center" prop="station">
            <template slot-scope="scope">
              <el-select ref="station1" v-model="scope.row.stationId" :disabled="low.auditStatus != 1" style="width: 100%"
                placeholder="请选择站点">
                <el-option v-for="item in stations" :key="item.id" :label="item.name" :value="item.id"
                  @click.native="scope.row.station = item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="原物料" align="center">
            <template slot-scope="scope">
              <el-select ref="rawId" v-model="scope.row.rawId" style="width: 100%" placeholder="请选择原物料">
                <el-option v-for="item in rawList" :key="item.rawId" :label="item.rawName" :value="item.rawId"
                  @click.native="scope.row.rawNmae = item.rawName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整类型" align="center" prop="deductionType">
            <template slot-scope="scope">
              <el-select ref="deductionType1" v-model="scope.row.deductionTypeId" style="width: 100%"
                placeholder="请选择调整类型" :disabled="low.auditStatus != 1">
                <el-option v-for="item in deductionTypes" :key="item.id" :label="item.itemName" :value="item.id"
                  @click.native="scope.row.deductionType = item.itemName"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调增调减" align="center" prop="addOrReduce">
            <template slot-scope="scope">
              <el-select ref="addOrReduce" v-model="scope.row.addOrReduce" style="width: 100%" placeholder="请选择"
                :disabled="low.auditStatus != 1">
                <el-option :key="1" label="调增" :value="1"></el-option>
                <el-option :key="2" label="调减" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="调整金额" align="center" prop="deduction">
            <template slot-scope="scope">
              <el-input v-model="scope.row.deduction" :disabled="low.auditStatus != 1" placeholder="请输入"
                style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.deduction = $regExp.checkNum(scope.row.deduction)"
                @blur="scope.row.deduction = $regExp.blurCheckNum(scope.row.deduction)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="是否影响开票" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.influenceInvoice" :disabled="low.auditStatus != 1">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="是否进入当月结算" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.isEnterSettle">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" prop="remark">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" :disabled="low.auditStatus != 1" placeholder="请输入" style="width: 100%"
                clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="low.auditStatus == 1" label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem1(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 结算合计 -->
        <div class="bill_title">
          结算合计
          <el-button v-if="low.auditStatus == 1" size="mini" class="bottom_all" style="margin-left: 24px"
            @click="addItem2()">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="totalList" tooltip-effect="dark" show-summary :summary-method="getTotalSummaries">
          <!-- <el-table-column label="开票单位" align="center" prop="cooperativeUnit">
            <template slot-scope="scope">
              <el-select v-if="scope.row.localstatus" ref="cooperativeUnit2" v-model="scope.row.cooperativeUnitId"
                :disabled="low.auditStatus != 1" filterable style="width: 100%" placeholder="请选择" @change="
                  $nextTick(() => {
                    scope.row.cooperativeUnit = $refs.cooperativeUnit2.selectedLabel;
                  }),
                  check3('结算合计', scope.$index)
                  ">
                <el-option v-for="item in cooperativeUnit" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <div v-else>{{ scope.row.cooperativeUnit }}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="待结算金额（元）" align="center" prop="settlementAmount">
            <template slot-scope="scope">
              <div>{{ scope.row.settlementAmount || scope.row.settlementAmount == 0 ? scope.row.settlementAmount : "---"
              }}</div>
            </template>
          </el-table-column>
          <el-table-column label="补差金额（元）" align="center" prop="compensateAmount">
            <template slot-scope="scope">
              <div>{{ scope.row.compensateAmount || scope.row.compensateAmount == 0 ? scope.row.compensateAmount : "---"
              }}</div>
            </template>
          </el-table-column>
          <el-table-column label="调整金额（元）" align="center" prop="deduction">
            <template slot-scope="scope">
              <div>{{ scope.row.deduction || scope.row.deduction == 0 ? scope.row.deduction : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="结算金额（元）" align="center" prop="realPay">
            <template slot-scope="scope">
              <div>{{ scope.row.realPay || scope.row.realPay == 0 ? scope.row.realPay : "---" }}</div>
            </template>
          </el-table-column>
          <el-table-column label="开票金额（元）" align="center" prop="faceAdjustment">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faceAdjustment" :disabled="low.auditStatus != 1" placeholder="请输入"
                style="width: 100%" onkeypress="return( /\d|\./.test(String.fromCharCode(event.keyCode)))"
                @input="scope.row.faceAdjustment = $regExp.checkNum(scope.row.faceAdjustment)"
                @blur="scope.row.faceAdjustment = $regExp.blurCheckNum(scope.row.faceAdjustment)"></el-input>
            </template>
          </el-table-column>
          <el-table-column v-if="low.auditStatus == 1" label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button size="mini" class="bottom_two" @click="delItem2(scope.$index)">
                <i class="icon iconfont iconicon_button_delete" style="font-size: 12px"></i>
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer" style="display: flex; justify-content: space-between">
        <div>
          <el-button class="bottom_all_two" :disabled="noPass" @click="downloadLink">下载结算单</el-button>
          <!-- <el-button v-if="billDetails1.auditStatus==1" class="bottom_all_two" @click="combinedSubmit(3)">提交审核</el-button> -->
          <!-- <el-button class="bottom_all_two" :disabled="noPass" @click="daYinTypeFun()">打印结算单</el-button> -->
          <!-- <el-button class="bottom_all_two" :disabled="noPass" @click="daYinAllTypeFun()">打印汇总结算单</el-button> -->
          <el-button class="bottom_all_two" :disabled="noPass" @click="downLoad()">导出汇总结算单</el-button>
        </div>
        <div>
          <el-button class="bottom_all_two" @click="billDeta1 = false">关 闭</el-button>
          <el-button v-if="low.auditStatus == 1" class="bottom_all" style="margin-left: 24px"
            @click="combinedSubmit_3()">保 存</el-button>
        </div>
      </span>
    </el-dialog>
    <!--选择发送的人员-->
    <!-- <el-dialog v-dialogDrag :visible.sync="userDeta" width="620px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">请选择接收账号</span>
      <div style="padding:0 10px">
        <el-checkbox-group v-model="userarr">
          <template v-for="(item,index) in useroptons">
            <el-checkbox :key="index" style="line-height:26px" :label="item.id">{{item.name}}</el-checkbox>
          </template>
        </el-checkbox-group>
        <div v-if="useroptons.length==0" style="color:#ccc;text-align: center;">无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="userDeta=false">取 消</el-button>
        <el-button class="bottom_all" :disabled="userarr.length==0" style="margin-left: 24px" @click="userSubmit()">发 送</el-button>
      </span>
    </el-dialog> -->
    <!--打印结算单-->
    <el-dialog v-dialogDrag :visible.sync="daYinType" width="1130px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">打印结算单预览</span>
      <div style="padding: 0 10px">
        <div id="dyBox">
          <div v-for="(item, index) in daYinFormFor" :key="index" style="page-break-after: always; margin-top: 10px">
            <div class="top">
              <div>采购结算书</div>
              <div>
                <div>
                  合同（协议）编号： <span>{{ item.contractNo }}</span>
                </div>
                <div>
                  结算周期： <span>{{ item.startTime ? item.startTime : "" }}至{{ item.endTime ? item.endTime : "" }}</span>
                </div>
              </div>
            </div>
            <div class="formBox">
              <div>
                <div>
                  <span class="table">采购类别<span></span></span>
                  <span>{{ item.rawType }}</span>
                </div>
                <div>
                  <span class="table">结算数量<span></span></span>
                  <span>{{ Number(item.statementNum).toFixedRound(2) }}</span>
                </div>
              </div>
              <div>
                <div style="position: relative" @mouseenter="receivingUnitType = true"
                  @mouseleave="receivingUnitType = false">
                  <span class="table">收货单位<span></span></span>
                  <span>{{ item.receivingUnit }}</span>
                  <el-select v-show="receivingUnitType" v-model="item.receivingUnit" placeholder="请选择"
                    style="width: 319px; position: absolute; top: -11px; left: 115px">
                    <el-option v-for="(item, k) in ReceivingUnitList" :key="k" :label="item.itemName"
                      :value="item.itemName"> </el-option>
                  </el-select>
                </div>
                <div>
                  <span class="table">结算金额<span></span></span>
                  <span>{{ Number(item.realPay).toFixedRound(2) }}</span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">负责人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">金额大写<span></span></span>
                  <span>{{ item.realPay0 }}</span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">审核人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">供货单位经办人<span></span></span>
                  <span></span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">经办人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">供货单位（章）<span></span></span>
                  <span>{{ item.supplier }}</span>
                </div>
              </div>
            </div>
            <div class="tableBox">
              <div>采购结算明细表</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="item.listByCu" tooltip-effect="dark">
                <el-table-column prop="receiveStation" label="站点"> </el-table-column>
                <el-table-column prop="rawName" label="材料名称"> </el-table-column>
                <el-table-column prop="specification" label="规格"> </el-table-column>
                <el-table-column label="计量单位">
                  <template>
                    <div>吨</div>
                  </template>
                </el-table-column>
                <el-table-column prop="statementNum" label="数量"> </el-table-column>
                <el-table-column prop="unitPrice" label="合同单价"> </el-table-column>
                <el-table-column prop="" label="调整单价">
                  <template slot-scope="scope">
                    {{ Number(scope.row.statementUnitPrice) - Number(scope.row.unitPrice) }}
                  </template>
                </el-table-column>
                <el-table-column prop="statementUnitPrice" label="结算单价"> </el-table-column>
                <el-table-column prop="" label="结算金额(元)">
                  <template slot-scope="scope">
                    {{ (scope.row.realPay = Number(scope.row.dealPrice) + Number(scope.row.increaseAmount)) }}
                  </template>
                </el-table-column>
                <el-table-column label="时间段" align="center">
                  <template slot-scope="scope"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"> </el-table-column>
              </el-table>
              <div style="padding: 20px 0">调整金额</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="item.deductionListByCu" tooltip-effect="dark">
                <!-- <el-table-column prop="cooperativeUnit" label="协作单位"> </el-table-column> -->
                <el-table-column prop="station" label="站点"> </el-table-column>
                <el-table-column prop="deductionType" label="调整类型"> </el-table-column>
                <el-table-column prop="deduction" label="调整金额"> </el-table-column>
                <el-table-column prop="remark" label="备注"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="daYinType = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="doPrint()">打 印</el-button>
      </span>
    </el-dialog>
    <!--打印汇总结算单-->
    <el-dialog v-dialogDrag :visible.sync="daYinAllType" width="1130px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">打印结算单预览</span>
      <div style="padding: 0 10px">
        <div id="dyAllBox">
          <div style="page-break-after: always; margin-top: 10px">
            <div class="top">
              <div>采购结算书</div>
              <div>
                <div>
                  合同（协议）编号： <span>{{ daYinAllForm.contractNo }}</span>
                </div>
                <div>
                  结算周期： <span>{{ daYinAllForm.startTime ? daYinAllForm.startTime : "" }}至{{ daYinAllForm.endTime ?
                    daYinAllForm.endTime : "" }}</span>
                </div>
              </div>
            </div>
            <div class="formBox">
              <div>
                <div>
                  <span class="table">采购类别<span></span></span>
                  <span>{{ daYinAllForm.rawType }}</span>
                </div>
                <div>
                  <span class="table">结算数量<span></span></span>
                  <span>{{ daYinAllForm.statementNum }}</span>
                </div>
              </div>
              <div>
                <div style="position: relative" @mouseenter="receivingUnitType = true"
                  @mouseleave="receivingUnitType = false">
                  <span class="table">收货单位<span></span></span>
                  <span>{{ daYinAllForm.receivingUnit }}</span>
                  <el-select v-show="receivingUnitType" v-model="daYinAllForm.receivingUnit" placeholder="请选择"
                    style="width: 319px; position: absolute; top: -11px; left: 115px">
                    <el-option v-for="(daYinAllForm, k) in ReceivingUnitList" :key="k" :label="daYinAllForm.itemName"
                      :value="daYinAllForm.itemName"> </el-option>
                  </el-select>
                </div>
                <div>
                  <span class="table">结算金额<span></span></span>
                  <span>{{ daYinAllForm.realPay }}</span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">负责人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">金额大写<span></span></span>
                  <span>{{ daYinAllForm.realPay0 }}</span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">审核人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">供货单位经办人<span></span></span>
                  <span></span>
                </div>
              </div>
              <div>
                <div></div>
                <div></div>
              </div>
              <div>
                <div>
                  <span class="table">经办人<span></span></span>
                  <span></span>
                </div>
                <div>
                  <span class="table">供货单位（章）<span></span></span>
                  <span>{{ daYinAllForm.cooperativeUnit }}</span>
                </div>
              </div>
            </div>
            <div class="tableBox">
              <div>采购结算明细表</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="daYinAllForm.listByCu" tooltip-effect="dark">
                <el-table-column prop="receiveStation" label="站点"> </el-table-column>
                <el-table-column prop="rawName" label="材料名称"> </el-table-column>
                <el-table-column prop="specification" label="规格"> </el-table-column>
                <el-table-column label="计量单位">
                  <template>
                    <div>吨</div>
                  </template>
                </el-table-column>
                <el-table-column prop="statementNum" label="数量"> </el-table-column>
                <el-table-column prop="unitPrice" label="合同单价"> </el-table-column>
                <el-table-column prop="" label="调整单价">
                  <template slot-scope="scope">
                    {{ Number(scope.row.statementUnitPrice) - Number(scope.row.unitPrice) }}
                  </template>
                </el-table-column>
                <el-table-column prop="statementUnitPrice" label="结算单价"> </el-table-column>
                <el-table-column prop="" label="结算金额(元)">
                  <template slot-scope="scope">
                    {{ (scope.row.realPay = Number(scope.row.dealPrice) + Number(scope.row.increaseAmount)) }}
                  </template>
                </el-table-column>
                <el-table-column label="时间段" align="center">
                  <template slot-scope="scope"> {{ scope.row.startTime }}至{{ scope.row.endTime }} </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"> </el-table-column>
              </el-table>
              <div style="padding: 20px 0">调整金额</div>
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :data="daYinAllForm.deductionListByCu" tooltip-effect="dark">
                <!-- <el-table-column prop="cooperativeUnit" label="协作单位"> </el-table-column> -->
                <el-table-column prop="station" label="站点"> </el-table-column>
                <el-table-column prop="deductionType" label="调整类型"> </el-table-column>
                <el-table-column prop="deduction" label="调整金额"> </el-table-column>
                <el-table-column prop="remark" label="备注"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="daYinAllType = false">关 闭</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="doPrint()">打 印</el-button>
      </span>
    </el-dialog>
    <!-- 选择补差 -->
    <el-dialog :visible.sync="sendersDig" width="960px" :close-on-click-modal="false" :append-to-body="true">
      <span slot="title" class="dialog-title">结算补差选择</span>
      <div class="dialoginfo">
        <el-table ref="senderDigTable" :header-cell-style="{ background: '#f3f6f9' }"
          :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="senderDigList"
          tooltip-effect="dark" :row-key="getRowKeys" @selection-change="changeSenders">
          <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column label="开票单位" align="center" prop="cooperativeUnit"></el-table-column>
          <el-table-column label="站点" align="center" prop="receiveStation"></el-table-column>
          <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
          <el-table-column label="补差日期" align="center">
            <template slot-scope="scope">
              {{ scope.row.compensateStartTime + "-" + scope.row.compensateEndTime }}
            </template>
          </el-table-column>
          <el-table-column label="补差数量" align="center" prop="compensateNum"></el-table-column>
          <el-table-column label="补差单价（元）" align="center" prop="compensatePrice"></el-table-column>
          <el-table-column label="补差金额（元）" align="center">
            <template slot-scope="scope">{{ Number(Number(scope.row.compensatePrice) *
              Number(scope.row.compensateNum)).toFixedRound(2) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="sendersDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="confirmSenders">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 业务记账单 -->
    <approvalForm ref="approvalForm" :dialog.sync="approvalFormDialog" :params="low" @openDialog="openDialog"
      @resetForm="resetForm" @mainLoadingClose="mainLoadingClose" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import approvalForm from "./docking/material/approvalForm.vue";
import {
  //queryPage1,
  queryPage2,
  queryPage3,
  get_contract_list,
  get_raw_list,
  //get_query_condition,
  generate_statement_detail,
  get_supplier,
  generate_statement_compensate,
  save_statement_detail,
  get_statement_detail,
  update_supplier_confirm,
  Download,
  Download2,
  update_statement_detail,
} from "@/api/wise/material.js";
import { _debounce, getSum } from "@/utils/utils.js";
import Decimal from "decimal.js";
import html2canvas from "html2canvas";
import { getUserInfo } from "@/utils/auth.js";
import { getcompany, getUserAutList } from "@/api/common.js";
import { cooperationqueryListsByPid } from "@/api/GHnumber/contract.js";
import { queryUserByID, informClient } from "@/api/wise/Wise_contactsbusiness/Wise_contactsbusiness.js";
import { getDicType, uploadFile } from "@/api/common.js";
export default {
  components: {
    approvalForm
  },
  mixins: [mixin],
  data() {
    return {
      //分页
      optionsPage: [
        {
          label: "10条/页",
          value: 10,
        },
        {
          label: "20条/页",
          value: 20,
        },
        {
          label: "30条/页",
          value: 30,
        },
        {
          label: "40条/页",
          value: 40,
        },
        {
          label: "50条/页",
          value: 50,
        },
        {
          label: "100条/页",
          value: 100,
        },
        {
          label: "200条/页",
          value: 200,
        },
        {
          label: "500条/页",
          value: 500,
        },
        {
          label: "1000条/页",
          value: 1000,
        },
        {
          label: "全部",
          value: 100000,
        },
      ],
      curElPage: 100000, //默认每页显示20条
      receivingUnitType: false,
      ReceivingUnitList: [],
      typelist: [],
      daYinForm: { list: [], receivingUnit: "请选择" },
      daYinFormFor: [], //打印for循环数据
      daYinType: false,
      daYinAllType: false,
      daYinAllForm: {},
      companyId: "",
      company: "",
      companylist: [],
      stationId: "",
      stationName: "",
      stationIdlist: [],
      /*表格增删改查及下载接口*/
      queryPage: "",
      download: Download,
      download2: Download2, //汇总结算单导出
      /*表格数据*/
      table: [],
      forceRefresh: false,
      table1: [
        { label: "皮重时间", width: "auto", prop: "actualReceiveTime", status: true },
        { label: "收货站点", width: "100", prop: "receiveStation", status: true },
        { label: "供应商", width: "120", prop: "supplier", status: true },
        { label: "协作单位", width: "120", prop: "cooperativeUnit", status: true },
        { label: "合同签订主体", width: "120", prop: "contractSigningSubject", status: true },
        { label: "甲供工程", width: "120", prop: "supplyEngineeringName", status: true },
        { label: "物料名称", width: "auto", prop: "rawName", status: true },
        { label: "运输车辆", width: "100", prop: "deliveryVehicl", status: true },
        { label: "货票量", width: "80", prop: "ticketNum", status: true },
        { label: "审核量", width: "80", prop: "receiveNum", status: true },
        { label: "集中供气", width: "80", prop: "supplyGas", status: true },
      ],
      table2: [
        { label: "结算单编号", width: "200", prop: "statementNo", status: true },
        { label: "供应商", width: "160", prop: "supplier", status: true },
        { label: "合同签订主体", width: "160", prop: "contractSigningSubject", status: true },
        { label: "结算时间段", width: "310", prop: "", status: true },
        { label: "结算总金额（元）", width: "140", prop: "statementAmount", status: true },
        { label: "提交时间", width: "160", prop: "submitTime", status: true },
        // { label: "附件", width: "160", prop: "picture", status: true },

        { label: "审核状态", width: "120", prop: "", status: true },
        { label: "共享状态", width: "120", prop: "shareResponse", status: true },
        { label: "供应商确认", width: "120", prop: "", status: true },
        { label: "操作", width: "120", prop: "", status: true },
      ],
      pagesType: 0,
      /**导航栏*/
      navlist: [
        {
          value: "待结算",
          id: 1,
        },
        {
          value: "已结算",
          id: 2,
        },
        {
          value: "结算单",
          id: 3,
        },
      ],
      currenindex: 1,
      datePicker: [],
      searchText: "",
      search: false,
      searchData: [],
      searchradio: "",
      cooperativeUnit: [],
      stations: [],
      rawId: [],
      contractId: [],
      generate: {
        logisticsList: [],
        clearingSourceId: "",
        startTime: "",
        endTime: "",
        contractId: "",
      },
      deductionTypes: [],
      /*结算单*/
      billDeta: false,
      billDetails: {},
      billList: [],
      sendersList: [],
      senderDigList: [],
      selectSendersList: [],
      sendersDig: false,
      spanArr: {},
      pos: "",
      deductionList: [],
      deductionListCopy: [],
      totalList: [],
      totalListCopy: [],
      /**查看阶段单*/
      billDeta1: false,
      UserInfo: {},
      billDetails1: { list: [] },
      userDeta: false,
      useroptons: [],
      userarr: [],
      low: {},
      cooperativeUnitArr: [], //调整金额-协作单位
      supplierNameSearch: "", //供应商弹窗筛选
      noPass: false, //审核状态未通过
      rawList: [], //调整金额原物料数据字典
      approvalFormDialog: false,
      mainLoading: false,
    };
  },
  async created() {
    const { data } = await getDicType({ code: "deductionType" });
    this.deductionTypes = data.items;
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, startTime: "", endTime: "", contractId: "", cooperativeUnitList: [], receiveStationIdList: [], rawIdList: "" };
    this.tableParam.pageSize = 100000;
    this.UserInfo = getUserInfo();
    if (this.UserInfo.adminStatus == 1) {
      /**通过typeId为公司类型id查询所有公司 */
      getcompany({ typeId: "19da56b9e85648059e3cf1e7da497da4" }).then(res => {
        this.companylist = res.data;
      });
    } else {
      this.stationIdlist = await getUserAutList(true);
    }
    getDicType({ code: "MATtype" }).then(res => {
      this.typelist = res.data.items;
    });
    getDicType({ code: "ReceivingUnitType" }).then(res => {
      this.ReceivingUnitList = res.data.items;
    });
  },
  watch: {
    billList: {
      handler() {
        // 每次 billList 变化后，强制刷新 el-table
        this.forceRefresh = !this.forceRefresh;
      },
      deep: true, 
    },
    currenindex: {
      handler() {
        this.tableData = [];
        this.datePicker = [];
        this.init();
        if (this.currenindex == 1) {
          this.searchText = "";
          this.table = this.table1;
          this.queryPage = queryPage2;
          this.tableParam.pageSize = 100000;
          this.tableParam["settlementStatusList"] = [0];
        }
        if (this.currenindex == 2) {
          this.table = this.table1;
          // this.queryPage = queryPage1;
          //this.getsearchData();
          this.queryPage = queryPage2;
          this.searchText = "";
          this.tableParam.pageSize = 10;
          this.curElPage = 10;
          this.tableParam["settlementStatusList"] = [1, 2];
        }
        if (this.currenindex == 3) {
          this.table = this.table2;
          this.queryPage = queryPage3;
          this.tableParam.pageSize = 10;
          this.curElPage = 10;
          this.getsearchData();
          this.gettableData();
        }
        //此处为执行的函数或者方法
      },
      deep: false, //是否深度监听，true为是，默认为false
      immediate: true, //immediate表示在watch中首次绑定的时候，是否执行handler,true为执行,默认为false
    },
    datePicker() {
      if (this.datePicker) {
        this.tableParam.startTime = this.datePicker[0];
        this.tableParam.endTime = this.datePicker[1];
        if (this.currenindex == 1 || this.currenindex == 2) {
          get_contract_list({ supplerName: this.supplierNameSearch, startDay: this.datePicker[0], endDay: this.datePicker[1] }).then(res => {
            this.searchData = res.data;
          });
        }
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
    tableData() {
      if (this.tableData.length !== 0) {
        this.$refs.table.toggleAllSelection();
        this.generate.startTime = this.tableParam.startTime;
        this.generate.endTime = this.tableParam.endTime;
        this.generate.contractId = this.tableParam.contractId;
      }
    },
    /**结算合计*/
    tatol: {
      handler() {
        this.settotalList();
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    tatol() {
      return {
        billList: this.billList,
        sendersList: this.sendersList,
        deductionList: this.deductionList,
      };
    },
  },
  methods: {
    dockSend(row) {
      this.low = row
      this.$refs.approvalForm.initData()
    },
    openDialog() {
      this.approvalFormDialog = true
      this.mainLoadingClose()
    },
    mainLoadingClose() {
      this.mainLoading = false
    },
    resetForm() {
      this.approvalFormDialog = false
    },
    /**
     * 财务智能小数格式化
     * @param {Number|String} val - 计算出的总和
     * @param {Number} precision - 默认最大保留位数（金额2位，数量3位）
     */
    formatFinanceNum(val, precision = 2) {
      const num = Number(val);
      if (isNaN(num)) return '';
      // 💡 判断是否为整数：如果是整数，直接输出整数（去掉所有.00）
      if (num % 1 === 0) {
        return num.toString();
      }
      // 💡 如果是小数，则强制保留对应的财务位数（防止 .20 变成 .2）
      return num.toFixed(precision);
    },
    /**
     * 结算单详情弹窗-表格合计方法
     * @param {Object} param - Element UI 传入的参数 { columns, data }
     * @param {Array} listData - 当前循环项的数据列表 (item.list)
     */
    getDetailSummaries(param, listData) {
      const { columns } = param;
      const sums = [];
      const add = this.decimal ? this.decimal.add : (a, b) => Number(a) + Number(b);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        sums[index] = '';
        const prop = column.property; 
        if (!prop) return;
        const needSumFields = ['receiveNum', 'statementUnitPrice', 'statementNum', 'unitPrice','dealPrice', 'increaseAmount', 'realPay'];
        if (needSumFields.includes(prop) && listData && listData.length > 0) {
          let total = 0;
          listData.forEach(item => {
            let val = Number(item[prop]);
            if (!isNaN(val)) {
              total = add(total, val);
            }
          });
          // 💡 统一改为调用 formatFinanceNum
          sums[index] = this.formatFinanceNum(total, 2); // 金额最大保留2位
        }
      });
      return sums;
    },
    /**
     * 结算合计-合计
     */
    getCompensateSummaries(param, currentList) {
      const { columns } = param;
      const sums = [];
      const add = this.decimal ? this.decimal.add : (a, b) => Number(a) + Number(b);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        sums[index] = '';
        const prop = column.property;
        if (!prop) return;
        const needSumFields = ['compensateNum', 'compensatePrice', 'compensateAmount'];
        if (needSumFields.includes(prop) && currentList && currentList.length > 0) {
          let total = 0;
          currentList.forEach(row => {
            let val = Number(row[prop]);
            if (!isNaN(val)) {
              total = add(total, val);
            }
          });
          // 💡 统一改为调用 formatFinanceNum
          sums[index] = this.formatFinanceNum(total, 2);
        }
      });
      return sums;
    },
    /**
     * 调整金额表格的专用合计方法（智能计算调增/调减）
     */
    getDeductionSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const add = this.decimal ? this.decimal.add : (a, b) => Number(a) + Number(b);
      const sub = this.decimal ? this.decimal.sub : (a, b) => Number(a) - Number(b);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        sums[index] = '';
        const prop = column.property;
        if (prop === 'deduction' && data && data.length > 0) {
          let total = 0;
          data.forEach(row => {
            let val = Number(row.deduction);
            if (!isNaN(val)) {
              if (row.addOrReduce === 0) {
                total = sub(total, val);
              } else {
                total = add(total, val);
              }
            }
          });
          sums[index] = this.formatFinanceNum(total, 2);
        }
      });
      return sums;
    },
    /**
     * 结算合计表格的专用合计方法
     * @param {Object} param - Element UI 传入的参数 { columns, data }
     */
    getTotalSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const add = this.decimal ? this.decimal.add : (a, b) => Number(a) + Number(b);
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        sums[index] = '';
        const prop = column.property;
        if (!prop) return;
        const needSumFields = ['settlementAmount', 'compensateAmount', 'deduction', 'realPay', 'faceAdjustment'];
        if (needSumFields.includes(prop) && data && data.length > 0) {
          let total = 0;
          data.forEach(row => {
            let val = row[prop];
            if (val === '---' || val === null || val === undefined || val === '') {
              val = 0;
            } else {
              val = Number(val);
            }
            if (!isNaN(val)) {
              total = add(total, val);
            }
          });
          sums[index] = this.formatFinanceNum(total, 2);
        }
      });
      return sums;
    },
    // 创建表尾
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        sums[index] = "";
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (column.label == "货票量") {
          sums[index] = getSum("ticketNum", data);
        }
        if (column.label == "审核量") {
          sums[index] = getSum("receiveNum", data);
        }
      });

      return sums;
    },
    toggleSelection(rows) {
      if (rows.length > 0) {
        this.$refs.senderDigTable.clearSelection();
        this.selectSendersList = [];
        rows.forEach(row => {
          row.detailId.forEach(detail => {
            let oneDetail = this.senderDigList.find(item => {
              return detail === item.detailId;
            });
            this.selectSendersList.push(oneDetail);
            this.$refs.senderDigTable.toggleRowSelection(oneDetail, true);
          });
        });
      } else {
        this.$refs.senderDigTable.clearSelection();
      }
    },
    getRowKeys(row) {
      return row.detailId; //一般是你选择项的id
    },
    async selectSenders() {
      this.selectSendersList = [];
      let arr = [];
      this.sendersDig = true;
      setTimeout(() => {
        this.sendersList?.forEach(item => {
          arr = [...arr, ...item.list];
        });
        this.toggleSelection(arr);
      }, 200);
    },
    changeSenders(val) {
      this.selectSendersList = [];
      this.selectSendersList = val;
    },
    confirmSenders() {
      this.sendersList = [];
      let copySelectSendersList = JSON.parse(JSON.stringify(this.selectSendersList));
      let sumSendersList = copySelectSendersList.reduce((pre, cur) => {
        let sameType = false;
        if (pre.length == 0) {
          let detailId = cur.detailId;
          cur.detailId = [];
          cur.detailId.push(detailId);
          pre.push(cur);
        } else {
          pre.forEach(item => {
            if (
              item.receiveStationId == cur.receiveStationId &&
              item.cooperativeUnitId == cur.cooperativeUnitId &&
              item.rawId == cur.rawId &&
              item.compensateStartTime == cur.compensateStartTime &&
              item.compensateEndTime == cur.compensateEndTime &&
              item.compensatePrice == cur.compensatePrice
            ) {
              sameType = true;
              item.compensateNum = Number(item.compensateNum * 1 + cur.compensateNum * 1).toFixedRound(2);
              item.detailId.push(cur.detailId);
            }
          });
          if (!sameType) {
            let detailId = cur.detailId;
            cur.detailId = [];
            cur.detailId.push(detailId);
            pre.push(cur);
          }
        }
        return pre;
      }, []);
      sumSendersList.forEach(val => {
        val.compensateAmount = Number(Number(val.compensatePrice) * Number(val.compensateNum)).toFixedRound(2);
        let index = this.sendersList.findIndex(item => item.cooperativeUnitId == val.cooperativeUnitId);
        console.log(index);
        if (index == -1) {
          let arr = [];
          arr.push(val);
          this.sendersList.push({ cooperativeUnit: val.cooperativeUnit, cooperativeUnitId: val.cooperativeUnitId, list: arr });
        } else {
          this.sendersList[index].list.push(val);
        }
      });
      console.log(this.sendersList);
      this.getSpanArr(this.sendersList);
      this.sendersDig = false;
    },
    /* */
    sendersSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        const _row = this.spanArr[row.cooperativeUnitId][rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex == 1) {
        console.log(this.spanArr);
        console.log(rowIndex);
        const _row = this.spanArr[row.receiveStationId + "station" + row.cooperativeUnitId][rowIndex];
        console.log("----------------", _row);
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex == 2) {
        const _row = this.spanArr[row.receiveStationId + "station" + row.cooperativeUnitId + "rawId" + row.rawId][rowIndex];
        console.log("----------------", _row);
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    getSpanArr(data) {
      if (data.length == 0) {
        return;
      }
      console.log("zmmm--", data); //从后台获取的数据
      this.spanArr = {};
      this.pos = 0;
      data.forEach(item => {
        item.list.forEach((items, indexs) => {
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[items.cooperativeUnitId] = [];
            this.spanArr[items.cooperativeUnitId].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[items.cooperativeUnitId][this.pos] += 1;
              this.spanArr[items.cooperativeUnitId].push(0);
            } else {
              // 不相等push 1
              let same = false;
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == items.cooperativeUnitId) {
                  same = true;
                }
              });
              if (!same) {
                this.spanArr[items.cooperativeUnitId] = [];
              }
              // this.spanArr[items.cooperativeUnitId].push(1);
              this.spanArr[items.cooperativeUnitId][indexs] = 1;
              this.pos = indexs;
            }
          }
        });
        item.list.forEach((items, indexs) => {
          let key = items.receiveStationId + "station" + items.cooperativeUnitId;
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[key] = [];
            this.spanArr[key].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId && items.receiveStationId === item.list[indexs - 1].receiveStationId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[key][this.pos] += 1;
              this.spanArr[key].push(0);
            } else {
              // 不相等push 1
              let same = false;
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == key) {
                  same = true;
                }
              });
              if (!same) {
                this.spanArr[key] = [];
              }
              // this.spanArr[items.receiveStationId].push(1);
              this.spanArr[key][indexs] = 1;
              this.pos = indexs;
            }
          }
        });
        item.list.forEach((items, indexs) => {
          let key = items.receiveStationId + "station" + items.cooperativeUnitId + "rawId" + items.rawId;
          if (indexs === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanArr[key] = [];
            this.spanArr[key].push(1);
            this.pos = 0;
          } else {
            if (items.cooperativeUnitId === item.list[indexs - 1].cooperativeUnitId && items.receiveStationId === item.list[indexs - 1].receiveStationId && items.rawId === item.list[indexs - 1].rawId) {
              // 如果itemCode相等就累加，并且push 0
              this.spanArr[key][this.pos] += 1;
              this.spanArr[key].push(0);
            } else {
              // 不相等push 1
              let same = false;
              Object.keys(this.spanArr).forEach(spanItem => {
                if (spanItem == key) {
                  same = true;
                }
              });
              if (!same) {
                this.spanArr[key] = [];
              }
              // this.spanArr[key].push(1);
              this.spanArr[key][indexs] = 1;
              this.pos = indexs;
            }
          }
        });
      });
      console.log(this.spanArr);
    },
    /**调整金额*/
    addItem1() {
      let obj = {
        // cooperativeUnitId: "",--注释协作单位
        // cooperativeUnit: "",
        stationId: "",
        station: "",
        deductionTypeId: "",
        deductionType: "",
        deduction: "",
        influenceInvoice: 0,
        isEnterSettle: 0,
        remark: "",
        addOrReduce: "",
      };
      this.deductionList.push(obj);
    },
    delItem1(index) {
      this.deductionList.splice(index, 1);
    },
    /**结算合计*/
    addItem2() {
      let obj = {
        // compensateAmount: "",
        // cooperativeUnit: "",--注释协作单位
        cooperativeUnitId: "",
        faceAdjustment: "",
        realPay: "",
        settlementAmount: "",
        statementNo: "",
        deduction: "",
        localstatus: true,
      };
      this.totalList.push(obj);
    },
    delItem2(index) {
      this.totalList.splice(index, 1);
    },
    downloadLink() {
      this.$Download(this.download, { statementNo: this.low.statementNo });
    },
    /**结算信息合计*/
    combined(arr) {
      let num = 0;
      arr.forEach(res => {
        num = this.decimal.add(Number(res.dealPrice), Number(res.increaseAmount), num);
      });
      return num;
    },
    /**结算补差合计*/
    combined2(item, arr) {
      let num = 0;
      arr.forEach(res => {
        num = this.decimal.add(Number(res.compensateAmount), num);
      });
      item["compensateAmount"] = num;
      return num;
    },
    /**结算合计*/
    // settotalList: _debounce(function () {
    //   let _this = this;
    //   let list = [];
    //   let totalList = [];
    //   let newtotalList = [];
    //   _this.billList.forEach(res => {
    //     list = list.concat(res.list);
    //   });
    //   let newsendersList = [];
    //   _this.sendersList.forEach(res => {
    //     let index = newsendersList.findIndex(item => item.cooperativeUnitId == res.cooperativeUnitId);
    //     if (index == -1) {
    //       console.log("------------------------");
    //       newsendersList.push({ cooperativeUnitId: res.cooperativeUnitId, compensateAmount: res.compensateAmount });
    //     } else {
    //       newsendersList[index].realPay = this.decimal.add(Number(res.compensateAmount), Number(newsendersList[index].compensateAmount))
    //     }
    //   });
    //   console.log(newsendersList);
    //   list.forEach(res => {
    //     console.log();
    //     let index = newtotalList.findIndex(item => item.cooperativeUnitId == res.cooperativeUnitId);
    //     if (index == -1) {
    //       newtotalList.push({
    //         cooperativeUnitId: res.cooperativeUnitId,
    //         cooperativeUnit: res.cooperativeUnit,
    //         settlementAmount: this.decimal.add(Number(res.dealPrice), Number(res.increaseAmount)),
    //         compensateAmount: null,
    //         realPay: this.decimal.add(Number(res.dealPrice), Number(res.increaseAmount)),
    //         faceAdjustment: this.decimal.add(Number(res.dealPrice), Number(res.increaseAmount)),
    //         statementNo: res.statementNo,
    //       });
    //     } else {
    //       newtotalList[index].settlementAmount = this.decimal.add(Number(newtotalList[index].settlementAmount), Number(res.dealPrice), Number(res.increaseAmount)),
    //         newtotalList[index].realPay = this.decimal.add(Number(newtotalList[index].realPay), Number(res.dealPrice), Number(res.increaseAmount)),
    //         newtotalList[index].faceAdjustment = this.decimal.add(Number(newtotalList[index].faceAdjustment), Number(res.dealPrice), Number(res.increaseAmount))
    //     }
    //   });
    //   totalList = newtotalList.map(res => {
    //     let item1 = newsendersList.find(item => item.cooperativeUnitId == res.cooperativeUnitId);
    //     let item2 = this.deductionList.filter(item => item.cooperativeUnitId == res.cooperativeUnitId);
    //     const sum = (prev, cur) => prev + (cur.influenceInvoice == 1 ? (cur.addOrReduce == 0 ? 0 - Number(cur.deduction) : Number(cur.deduction)) : 0);
    //     const sum2 = (prev, cur) => prev + (cur.isEnterSettle != 0 ? (cur.addOrReduce == 0 ? 0 - Number(cur.deduction) : Number(cur.deduction)) : 0);
    //     let deduction = item2.reduce(sum2, 0);
    //     let deduction2 = item2.reduce(sum, 0);

    //     console.log(sum2);
    //     console.log(deduction);
    //     let obj = new Object();
    //     obj.compensateAmount = 0;
    //     if (item1) {
    //       obj.compensateAmount = item1.compensateAmount;
    //     }
    //     obj.cooperativeUnit = res.cooperativeUnit;
    //     obj.cooperativeUnitId = res.cooperativeUnitId;
    //     obj.faceAdjustment = this.decimal.add(res.faceAdjustment * 1, obj.compensateAmount * 1, (deduction2 * 1 || 0))
    //     console.log(res.settlementAmount, obj.compensateAmount, deduction);
    //     obj.realPay = this.decimal.add(res.settlementAmount * 1, obj.compensateAmount * 1, (deduction2 * 1 || 0))
    //     console.log(obj.realPay);
    //     obj.settlementAmount = res.settlementAmount;
    //     console.log(obj.settlementAmount);
    //     obj.deduction = deduction || 0;
    //     obj.statementNo = null;
    //     return obj;
    //   });
    //   let totalList1 = _this.totalList.filter(res => res.localstatus);
    //   _this.totalList = [...totalList, ...totalList1];
    //   console.log(_this.totalList);
    // }, 500),
    /**结算合计--取消协作单位维度*/
    settotalList: _debounce(function () {
      let _this = this;
    
      // 拿到所有的结算信息明细（打平到一个一维数组里）
      let list = [];
      _this.billList.forEach(res => {
        list = list.concat(res.list);
      });
      // 待结算金额全局求和
      let totalSettlementAmount = 0;
      list.forEach(res => {
        totalSettlementAmount = this.decimal.add(totalSettlementAmount, Number(res.dealPrice || 0), Number(res.increaseAmount || 0));
      });
      // 补差金额全局求和（并把各组的补差回写给外层对象以便展示）
      let totalCompensateAmount = 0;
      _this.sendersList.forEach(res => {
        let groupCompensateAmount = 0;
        if (res.list && res.list.length > 0) {
          res.list.forEach(child => {
            groupCompensateAmount = this.decimal.add(Number(child.compensateAmount || 0), groupCompensateAmount);
            totalCompensateAmount = this.decimal.add(Number(child.compensateAmount || 0), totalCompensateAmount);
          });
        }
        res.compensateAmount = groupCompensateAmount; // 给补差列表的小计回写数值
      });
      // 调整金额全局求和
      let totalDeductionForSettle = 0;  // 影响进入当月结算的
      let totalDeductionForInvoice = 0; // 影响开票金额的
      this.deductionList.forEach(cur => {
        let val = Number(cur.deduction || 0);
        // 是否进入当月结算
        if (cur.isEnterSettle == 1) { 
          totalDeductionForSettle = this.decimal.add(totalDeductionForSettle, cur.addOrReduce == 0 ? -val : val);
        }
        // 是否影响开票
        if (cur.influenceInvoice == 1) { 
          totalDeductionForInvoice = this.decimal.add(totalDeductionForInvoice, cur.addOrReduce == 0 ? -val : val);
        }
      });
      // 计算最终的实付金额与开票金额
      let realPay = this.decimal.add(totalSettlementAmount, totalCompensateAmount, totalDeductionForSettle);
      let faceAdjustment = this.decimal.add(totalSettlementAmount, totalCompensateAmount, totalDeductionForInvoice);
      // 生成唯一的一行自动汇总数据 (注意这里去掉了 cooperativeUnit)
      let autoRow = {
        settlementAmount: totalSettlementAmount,
        compensateAmount: totalCompensateAmount,
        deduction: totalDeductionForSettle, 
        realPay: realPay,
        faceAdjustment: faceAdjustment,
        localstatus: false
      };

      // 保留用户手动点击“添加”按钮加进来的行（如果有的话）
      let manualRows = _this.totalList.filter(res => res.localstatus);
      // 重新赋值给结算合计列表，永远只有（1行自动合计 + 手动加的行）
      _this.totalList = [autoRow, ...manualRows];
    }, 500),
    /**表格选中*/
    pageshandleSelectionChange(val) {
      this.generate.logisticsList = val.map(res => {
        let obj = new Object();
        obj.cooperativeUnit = res.cooperativeUnit;
        obj.cooperativeUnitId = res.cooperativeUnitId;
        obj.rawId = res.rawId;
        obj.rawName = res.rawName;
        obj.supplyGas = res.supplyGas;
        obj.airFeedCost = res.airFeedCost;
        obj.receiveStation = res.receiveStation;
        obj.receiveStationId = res.receiveStationId;
        obj.receiveNum = res.receiveNum;
        obj.actualReceiveTime = res.actualReceiveTime;
        obj.consignmentId = res.id;
        obj.carNo = res.deliveryVehicl;
        obj.ticketNum = res.ticketNum;
        obj.unitPrice = res.price;
        obj.specification = res.specification;
        obj.carContractId = res.carContractId;
        return obj;
      });
    },
    /**生成结算单h和补差价*/
    async statements() {
      let _this = this;
      this.deductionList = [];
      await generate_statement_detail(this.generate).then(res => {
        _this.billDetails = res.data;
        _this.billDetails["contractSigningSubject"] = this.tableData[0].contractSigningSubject;
        console.log(this.billDetails.cooperativeUnit);
        _this.billList = [];
        this.cooperativeUnitArr = [];
        const stationName = [];
        //结算信息--开始
        // res.data.list.forEach(res => {
        //   stationName.push(res.receiveStation);
        //   let index = _this.billList.findIndex(item => item.cooperativeUnitId == res.cooperativeUnitId && item.rawId == res.rawId);
        //   if (index == -1) {
        //     let arr = [];
        //     arr.push(res);
        //     _this.billList.push({ cooperativeUnit: res.cooperativeUnit, cooperativeUnitId: res.cooperativeUnitId, rawName: res.rawName, rawId: res.rawId, list: arr });
        //   } else {
        //     _this.billList[index].list.push(res);
        //   }
        // });
        res.data.list.forEach(res => {
          stationName.push(res.receiveStation);
          // 只按 rawId (原物料) 维度去重查找
          let index = _this.billList.findIndex(item => item.rawId == res.rawId);
          if (index == -1) {
            let arr = [];
            arr.push(res);
            // 不再记录外层的 cooperativeUnitId
            _this.billList.push({ rawName: res.rawName, rawId: res.rawId, list: arr });
          } else {
            _this.billList[index].list.push(res);
          }
        });
        //结算信息--完成
        console.log(JSON.parse(JSON.stringify(this.billList)));
        this.rawList = this.billList.filter((item, index, self) => {
          // 返回第一个匹配项的索引，用于判断当前项是否为第一个匹配项
          const firstIndex = self.findIndex(obj => obj.rawId === item.rawId);

          // 如果当前项是第一个匹配项，则保留，否则过滤掉
          return index === firstIndex;
        });
        // this.cooperativeUnitArr = this.billList.map(res => {
        //   return {
        //     name: res.cooperativeUnit,
        //     id: res.cooperativeUnitId,
        //   };
        // });
        let obj = {};
        // this.cooperativeUnitArr = this.billList.reduce((pre, cur) => {
        //   if (!obj[cur["cooperativeUnitId"]]) {
        //     obj[cur["cooperativeUnitId"]] = true;
        //     pre.push({
        //       name: cur.cooperativeUnit,
        //       id: cur.cooperativeUnitId,
        //     });
        //   }
        //   return pre;
        // }, []);
        this.cooperativeUnitArr = res.data.list.reduce((pre, cur) => {
          if (!obj[cur["cooperativeUnitId"]]) {
            obj[cur["cooperativeUnitId"]] = true;
            pre.push({
              name: cur.cooperativeUnit,
              id: cur.cooperativeUnitId,
            });
          }
          return pre;
        }, []);
        console.log(JSON.parse(JSON.stringify(this.cooperativeUnitArr)));
        this.stationName = Array.from(new Set(stationName)).join(",");
        this.deductionList = res.data.deductionList;
      });
      let data = {
        logisticsList: this.generate.logisticsList,
        contractId: this.tableParam.contractId,
        clearingSourceId: this.generate.clearingSourceId,
      };
      // this.deductionList
      // let deductionList = this.generate.logisticsList.filter(item => item.supplyGas == 1);
      // console.log(deductionList);
      // deductionList.forEach(item => {
      //   this.deductionList.push({
      //     cooperativeUnitId: item.cooperativeUnitId,
      //     cooperativeUnit: item.cooperativeUnit,
      //     stationId: item.receiveStationId,
      //     station: item.receiveStation,
      //     deductionTypeId: "146716069174841344",
      //     deductionType: "集中供气",
      //     deduction: item.airFeedCost,
      //     influenceInvoice: 0,
      //     remark: "",
      //   });
      // });

      _this.sendersList = [];
      await generate_statement_compensate(data).then(res2 => {
        if (res2.data) {
          let list2 = res2.data;
          this.senderDigList = list2;
        }
      });
      _this.billDeta = true;
    },
    /**结算单发给供应商*/
    send(low) {
      this.low = low;
      this.userarr = [];
      this.useroptons = [];
      queryUserByID({ id: low.contractId }).then(res => {
        this.useroptons = res.data;
        this.userDeta = true;
      });
    },
    async userSubmit(low) {
      this.$confirm("确认发送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      }).then(async () => {
        let json = {
          contractId: low.contractId,
          type: 2,
          settlementId: low.id,
          settlementNo: low.statementNo,
          times: low.startTime + "-" + low.endTime,
          money: low.statementAmount,
          applyForTime: low.submitTime,
          imgUrl: low.picture,
        };
        // let arr = this.userarr.map(res => (new useritem(res)))
        await informClient(json).then(res => {
          if (res.code == 1001) {
            update_supplier_confirm({ statementNo: low.statementNo, supplierConfirm: 1 }).then(() => { });
            this.$message({
              message: "发送成功",
              type: "success",
            });
            this.gettableData();
            this.userDeta = false;
          }
        });
      });
    },
    /**保存结算单*/
    async combinedSubmit(num) {
      let self = this;
      const hasEmptyRawId = this.deductionList?.some(item => !item.rawId);
      if (hasEmptyRawId) {
        this.$message.warning('调整金额列表原物料不能为空！');
        return;
      }
      let data = new Object();
      new Promise(resolve => {
        html2canvas(self.$refs.html).then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], "结算截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl);
              }
            });
          });
        });
      }).then(value => {
        let list = [];
        let total = 0;
        let total2 = 0;
        self.billList.forEach(res => {
          list = list.concat(res.list);
        });
        console.log(self.totalList);
        self.totalList.forEach(res => {
          total = total + Number(res.realPay);
          total2 = total2 + Number(res.faceAdjustment);
        });
        // if (total !== total2) {
        //   self.$message({
        //     message: "开票金额之和要等于实付金额之和",
        //     type: "warning",
        //   });
        //   return;
        // }
        data.list = list;
        let sendersListArr = [];
        self.sendersList.forEach(res => {
          res.list.forEach(res2 => {
            res2.detailId = res2.detailId.join(",");
          });
          sendersListArr = sendersListArr.concat(res.list);
        });
        data.picture = value;
        data.compensateList = sendersListArr;
        data.logisticsList = self.billDetails.logisticsList;
        data.clearingSourceId = self.generate.clearingSourceId;
        data.statementNo = self.billDetails.statementNo;
        data.supplier = JSON.parse(self.searchradio).supplierName;
        data.supplierId = JSON.parse(self.searchradio).supplierId;
        data.startTime = self.tableParam.startTime;
        data.endTime = self.tableParam.endTime;
        data.statementAmount = total; // 结算合计，合计
        data.operation = 0; //0：保存，1：提交审核
        data.submitTime = new Date().Format("yyyy-MM-dd hh:mm:ss"); // 提交审核时间
        data.contractId = self.tableParam.contractId;
        data.contractNo = self.tableParam.contractNo;
        data.rawTypeId = self.tableParam.rawTypeId;
        data.rawType = self.tableParam.rawType;
        data.deductionList = self.deductionList;
        data.company = self.company;
        data.companyId = self.companyId;
        data.totalList = self.totalList;
        save_statement_detail(data).then(res => {
          if (res.code == 1001) {
            self.billDeta = false;
            if (num == 1) {
              self.$router.push({ name: "sign_material", query: { id: res.data, type: 1 } });
              return;
            }
            self.$message({
              message: "保存成功",
              type: "success",
            });
            self.gettableData();
          }
        });
      });
    },
    /**修改结算单 */
    combinedSubmit_3() {
      let self = this;
      const hasEmptyRawId = this.deductionList?.some(item => !item.rawId);
      if (hasEmptyRawId) {
        this.$message.warning('调整金额列表原物料不能为空！');
        return;
      }
      new Promise(resolve => {
        html2canvas(self.$refs.html).then(canvas => {
          canvas.toBlob(blob => {
            const file = new File([blob], "结算截图.jpg", { type: "image/jpg" });
            const params = new FormData();
            params.append("file", file);
            uploadFile(params).then(res => {
              if (res.code === 1001) {
                resolve(res.data.fileUrl);
              }
            });
          });
        });
      }).then(value => {
        let list = [];
        let total = 0;
        let total2 = 0;
        self.billList.forEach(res => {
          list = list.concat(res.list);
        });
        console.log(self.totalList);
        self.totalList.forEach(res => {
          total = total + Number(res.realPay);
          total2 = total2 + Number(res.faceAdjustment);
        });
        // if (total !== total2) {
        //   self.$message({
        //     message: "开票金额之和要等于实付金额之和",
        //     type: "warning",
        //   });
        //   return;
        // }
        let form = {};
        form = self.billDetails1;
        form.list = list;
        let compensateList = [];
        self.sendersList.forEach(res => {
          res.list.forEach(res2 => {
            res2.detailId = res2.detailId.join(",");
          });
          compensateList = compensateList.concat(res.list);
        });
        form.compensateList = compensateList;
        form.picture = value;
        // //调整金额 数据处理开始
        // let deductionList = [];
        // let update = self.deductionList.filter(res => self.deductionListCopy.some(item => res.id == item.id));
        // let deleteData = self.deductionListCopy.filter(res => !update.some(item => res.id == item.id));
        // deleteData.forEach(res => {
        //   res.status = 0; //0是删除
        // });
        // let addData = self.deductionList.filter(
        //   //新增的type默认写死为 1
        //   res => !update.some(item => res.id == item.id)
        // );
        // deductionList = [...update, ...deleteData, ...addData];
        // form.deductionList = deductionList;
        // //调整金额 数据处理结束
        form.totalList = self.totalList;
        form.operation = 0;
        form.statementAmount = total; // 结算合计，合计
        update_statement_detail(form).then(res => {
          if (res.code == 1001) {
            self.billDeta1 = false;
            self.$message({
              message: "保存成功",
              type: "success",
            });
            self.gettableData();
          }
        });
      });
    },
    show(low) {
      this.low = low;
      (this.noPass = low.auditStatus == 4 ? true : false),
        get_statement_detail({ statementNo: low.statementNo }).then(async res => {
          if (res.code == 1001) {
            cooperationqueryListsByPid({ supplierId: res.data.supplierId }).then(res => {
              this.cooperativeUnit = res.data;
            });
            this.billDetails1 = res.data;
            this.billDetails1["contractSigningSubject"] = this.low.contractSigningSubject;
            this.daYinForm = res.data;
            this.deductionList = res.data.deductionList;
            this.deductionListCopy = JSON.parse(JSON.stringify(res.data.deductionList));
            this.stations = JSON.parse(res.data.stations);
            console.log(this.stations);
            this.billDeta1 = true;
            this.billList = [];
            this.cooperativeUnitArr = [];
            // res.data.list.forEach(res => {
            //   let index = this.billList.findIndex(item => item.cooperativeUnitId == res.cooperativeUnitId && item.rawId == res.rawId);
            //   if (index == -1) {
            //     let arr = [];
            //     arr.push(res);
            //     this.billList.push({ cooperativeUnit: res.cooperativeUnit, cooperativeUnitId: res.cooperativeUnitId, rawName: res.rawName, rawId: res.rawId, list: arr });
            //   } else {
            //     this.billList[index].list.push(res);
            //   }
            // });
            res.data.list.forEach(res => {
              // 只按 rawId (原物料) 维度去重查找
              let index = this.billList.findIndex(item => item.rawId == res.rawId);
              if (index == -1) {
                let arr = [];
                arr.push(res);
                this.billList.push({ rawName: res.rawName, rawId: res.rawId, list: arr });
              } else {
                this.billList[index].list.push(res);
              }
            });
            console.log(JSON.parse(JSON.stringify(this.billList)));
            this.rawList = this.billList.filter((item, index, self) => {
              // 返回第一个匹配项的索引，用于判断当前项是否为第一个匹配项
              const firstIndex = self.findIndex(obj => obj.rawId === item.rawId);

              // 如果当前项是第一个匹配项，则保留，否则过滤掉
              return index === firstIndex;
            });
            // this.cooperativeUnitArr = this.billList.map(res => {
            //   return {
            //     name: res.cooperativeUnit,
            //     id: res.cooperativeUnitId,
            //   };
            // });
            let obj = {};
            // this.cooperativeUnitArr = this.billList.reduce((pre, cur) => {
            //   if (!obj[cur["cooperativeUnitId"]]) {
            //     obj[cur["cooperativeUnitId"]] = true;
            //     pre.push({
            //       name: cur.cooperativeUnit,
            //       id: cur.cooperativeUnitId,
            //     });
            //   }
            //   return pre;
            // }, []);
            this.cooperativeUnitArr = res.data.list.reduce((pre, cur) => {
              if (!obj[cur["cooperativeUnitId"]]) {
                obj[cur["cooperativeUnitId"]] = true;
                pre.push({
                  name: cur.cooperativeUnit,
                  id: cur.cooperativeUnitId,
                });
              }
              return pre;
            }, []);
            console.log(JSON.parse(JSON.stringify(this.cooperativeUnitArr)));
            this.sendersList = [];
            let list2 = this.billDetails1.compensateList;
            list2.forEach(val => {
              val.detailId = val.detailId.split(",");
              let index = this.sendersList.findIndex(item => item.cooperativeUnitId == val.cooperativeUnitId);
              if (index == -1) {
                let arr = [];
                arr.push(val);
                this.sendersList.push({ cooperativeUnit: val.cooperativeUnit, cooperativeUnitId: val.cooperativeUnitId, list: arr });
              } else {
                this.sendersList[index].list.push(val);
              }
            });
            this.getSpanArr(this.sendersList);
            console.log(this.sendersList);
          }
          //补差列表
          let data = {
            //logisticsList: res.data.logisticsList,
            contractId: this.low.contractId,
            statementNo: this.low.statementNo,
            //clearingSourceId: this.low.clearingSourceId,
          };
          await generate_statement_compensate(data).then(res2 => {
            if (res2.data) {
              let list2 = res2.data;
              this.senderDigList = list2;
            }
          });
        });
    },
    /**搜索条件单选选中*/
    setradio(data) {
      this.searchradio = JSON.stringify(data);
      this.companyId = data.firstPartyId;
      this.company = data.firstParty;
    },
    /**获取对应的搜索条件*/
    getsearchData() {
      let _this = this;
      // if (_this.currenindex == 2) {
      //   get_query_condition().then(res => {
      //     _this.cooperativeUnit = res.data.getCooperativeUnitlist.map(res => {
      //       return { name: res.cooperativeUnit, id: res.cooperativeUnitId };
      //     });
      //     _this.rawId = res.data.getRawList.map(res => {
      //       return { productName: res.rawName, id: res.rawId };
      //     });
      //   });
      //   get_supplier({ settled: 1 }).then(res => {
      //     _this.contractId = res.data;
      //   });
      // }
      if (_this.currenindex == 1 || _this.currenindex == 2) {
        get_contract_list({ supplerName: this.supplierNameSearch, startDay: this.datePicker[0], endDay: this.datePicker[1] }).then(res => {
          _this.searchData = res.data;
        });
      }
      if (_this.currenindex == 3) {
        get_supplier({ settled: 0 }).then(res => {
          _this.searchData = res.data;
        });
      }
    },
    /**供应商选择*/
    submitsearch() {
      let text = JSON.parse(this.searchradio);
      this.tableParam.contractId = text.id;
      this.tableParam.contractNo = text.contractNumber;
      this.generate.clearingSourceId = text.clearingSourceId;
      this.generate.supplier = text.supplierName;
      this.generate.supplierId = text.supplierId;
      this.searchText = text.contractNumber + "-" + text.supplierName;
      cooperationqueryListsByPid({ supplierId: text.supplierId }).then(res => {
        this.cooperativeUnit = res.data;
      });
      this.stations = JSON.parse(text.stations);
      get_raw_list({ contractId: this.tableParam.contractId }).then(res => {
        this.rawId = res.data;
      });
      this.tableParam.clearingSourceId = text.clearingSourceId;
      this.tableParam.cooperativeUnitList = [];
      this.tableParam.receiveStationIdList = [];
      this.tableParam.rawIdList = [];
      this.search = false;
    },
    /**判断供应商和时间必传*/
    pagesgettableData() {
      if (
        (this.tableParam.contractId && this.tableParam.rawTypeId && this.datePicker && this.datePicker.length !== 0 && this.currenindex === 1) ||
        (this.tableParam.contractId && this.datePicker && this.datePicker.length !== 0 && this.currenindex === 2) ||
        this.currenindex === 3
      ) {
        this.gettableData();
        return;
      }
      this.$message({
        message: "警告哦，请先选择供应商,原物料类型,时间段后查询",
        type: "warning",
      });
    },
    /*导航栏切换*/
    choose(num) {
      this.currenindex = num;
    },
    /*重置查询条件*/
    init() {
      this.tableData = [];
      if (this.currenindex == 3) {
        this.tableParam = { ...this.$options.data().tableParam, statementNo: "", supplierId: "" };
      } else {
        this.tableParam = { ...this.$options.data().tableParam, startTime: "", endTime: "", contractId: "", cooperativeUnitList: [], receiveStationIdList: [], rawIdList: [] };
        this.searchradio = "";
        this.cooperativeUnit = [];
        this.stations = [];
        this.rawId = [];
        this.datePicker = [];
        this.searchText = "";
        if (this.currenindex == 1) {
          this.tableParam["settlementStatusList"] = [0];
        }
        if (this.currenindex == 2) {
          this.tableParam["settlementStatusList"] = [1, 2];
        }
      }
    },
    check3(name, index) {
      if (name == "结算合计") {
        this.billDetails1.totalList.forEach((v, k) => {
          if (index != k && v.cooperativeUnitId == this.billDetails1.totalList[index].cooperativeUnitId) {
            this.billDetails1.totalList[index].cooperativeUnitId = "";
            this.$message({
              message: "已存在当前选择开票单位！",
              type: "warning",
            });
          }
        });
      }
    },
    check1(name, index) {
      if (name == "结算合计") {
        this.totalList.forEach((v, k) => {
          if (index != k && v.cooperativeUnitId == this.totalList[index].cooperativeUnitId) {
            this.totalList[index].cooperativeUnitId = "";
            this.$message({
              message: "已存在当前选择开票单位！",
              type: "warning",
            });
          }
        });
      }
    },
    find(str, cha, num) {
      var x = str.indexOf(cha);
      for (var i = 0; i < num; i++) {
        x = str.indexOf(cha, x + 1);
      }
      return x;
    },
    daYinTypeFun() {
      this.daYinType = true;
      this.daYinForm = { ...this.billDetails1, receivingUnit: "请选择" };
      //打印结算单for循环数据开始
      this.daYinFormFor = [];
      console.log("====================");
      console.log(this.totalList);
      // this.totalList.forEach(item => {
      //   let list = [];
      //   let deductionList = [];
      //   let childForm = {};
      //   list = this.daYinForm.list.filter(listItem => listItem.cooperativeUnitId == item.cooperativeUnitId);
      //   deductionList = this.deductionList.filter(deductionListItem => deductionListItem.cooperativeUnitId == item.cooperativeUnitId);
      //   childForm = JSON.parse(JSON.stringify(this.daYinForm));
      //   childForm["listByCu"] = JSON.parse(JSON.stringify(list));
      //   childForm["deductionListByCu"] = JSON.parse(JSON.stringify(deductionList));
      //   this.$set(childForm, "realPay", item.realPay);
      //   this.$set(childForm, "cooperativeUnitId", item.cooperativeUnitId);
      //   this.$set(childForm, "cooperativeUnit", item.cooperativeUnit);
      //   let cu = this.cooperativeUnit.filter(cu => cu.id == item.cooperativeUnitId);
      //   console.log(cu);
      //   this.$set(childForm, "cooperationNumber", cu[0]?.cooperationNumber);
      //   childForm.realPay0 = this.digitUppercase(item.realPay);
      //   let statementNum = 0;
      //   childForm.listByCu.forEach(v => {
      //     statementNum = (statementNum + Number(v.statementNum)) | 0;
      //     let index = this.find(v.rawName, "_", 1);
      //     v.rawName = v.rawName.substring(0, index - 1);
      //   });
      //   childForm.statementNum = statementNum;
      //   childForm.receivingUnit = this.billDetails1.contractSigningSubject;
      //   this.daYinFormFor.push(childForm);
      // });
      //打印结算单for循环数据结束
    },
    daYinAllTypeFun() {
      this.daYinAllType = true;
      this.daYinAllData();
    },
    daYinAllData() {
      this.daYinAllForm = { ...this.billDetails1, receivingUnit: "请选择" };
      //打印结算单数据开始
      let billList = [];
      let statementNum = 0;
      let realPay = 0;
      let deduction = 0;
      let deductionList = JSON.parse(JSON.stringify(this.deductionList));
      this.billDetails1.list.forEach(res => {
        console.log(res);
        let index = billList.findIndex(item => item.rawId == res.rawId && item.startTime == res.startTime && item.endTime == res.endTime && item.receiveStationId == res.receiveStationId);

        if (index == -1) {
          billList.push(res);
        } else {
          billList[index].statementNum = Number(billList[index].statementNum * 1 + res.statementNum * 1).toFixedRound(2);
          billList[index].statementUnitPrice = Number(billList[index].statementUnitPrice * 1 + res.statementUnitPrice * 1).toFixedRound(2);
          billList[index].unitPrice = Number(billList[index].unitPrice * 1 + res.unitPrice * 1).toFixedRound(2);
          billList[index].dealPrice = Number(billList[index].dealPrice * 1 + res.dealPrice * 1).toFixedRound(2);
          billList[index].increaseAmount = Number(billList[index].increaseAmount * 1 + res.increaseAmount * 1).toFixedRound(2);
        }
      });
      deductionList.forEach(item => {
        item.deduction = item.isEnterSettle == 1 ? (item.addOrReduce == 1 ? item.deduction : 0 - item.deduction) : 0;
        deduction = Number(deduction * 1 + item.deduction * 1).toFixedRound(2);
      });

      billList.forEach(item => {
        item.realPay = Number(Number(item.dealPrice) + Number(item.increaseAmount)).toFixedRound(2);
        console.log(item.realPay * 1);
        console.log(realPay * 1);
        statementNum = Number(statementNum * 1 + item.statementNum * 1).toFixedRound(2);
        realPay = Number(realPay * 1 + item.realPay * 1).toFixedRound(2);
        console.log(realPay * 1);
      });
      this.$set(this.daYinAllForm, "cooperativeUnit", this.daYinAllForm.supplier);
      this.$set(this.daYinAllForm, "receivingUnit", this.daYinAllForm.contractSigningSubject);
      this.$set(this.daYinAllForm, "statementNum", statementNum);
      let realPayDecimal = new Decimal(realPay * 1).add(deduction * 1);
      this.$set(this.daYinAllForm, "realPay", realPayDecimal);
      this.$set(this.daYinAllForm, "realPay0", this.digitUppercase(realPayDecimal));
      this.daYinAllForm.listByCu = JSON.parse(JSON.stringify(billList));
      this.daYinAllForm.deductionListByCu = JSON.parse(JSON.stringify(deductionList));
      console.log(this.daYinAllForm);
      //打印结算单数据结束
    },
    /*导出汇总结算单 */
    async downLoad() {
      await this.daYinAllData();
      let params = JSON.parse(JSON.stringify(this.daYinAllForm));
      params.compensateList = null;
      this.$Download(this.download2, params);
    },
    /**打印*/
    doPrint() {
      if (!this.daYinForm.receivingUnit === "请选择") {
        this.$message({
          message: "请选择收货单位",
          type: "warning",
        });
        return;
      }
      // const style = '@page {margin:0mm}'//margin：0去掉页眉页脚，
      this.$print({
        // style,//设置边距
        printable: "dyBox",
        type: "html",
        maxWidth: "auto",
        font_size: "auto",
        targetStyles: ["*"], //必须保留样式
      });
    },
    /**汇总打印*/
    doAllPrint() {
      if (!this.daYinAllForm.receivingUnit === "请选择") {
        this.$message({
          message: "请选择收货单位",
          type: "warning",
        });
        return;
      }
      // const style = '@page {margin:0mm}'//margin：0去掉页眉页脚，
      this.$print({
        // style,//设置边距
        printable: "dyAllBox",
        type: "html",
        maxWidth: "auto",
        font_size: "auto",
        targetStyles: ["*"], //必须保留样式
      });
    },
    digitUppercase(money) {
      const cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖");
      const cnIntRadice = new Array("", "拾", "佰", "仟");
      const cnIntUnits = new Array("", "万", "亿", "兆");
      const cnDecUnits = new Array("角", "分", "毫", "厘");
      const cnInteger = "整";
      const cnIntLast = "元";
      const maxNum = 999999999999999.9999;
      let integerNum;
      let decimalNum;
      let chineseStr = "";
      let parts;
      if (money == "") {
        return "";
      }
      money = parseFloat(money);
      if (money >= maxNum) {
        //超出最大处理数字
        return "";
      }
      if (money == 0) {
        chineseStr = cnNums[0] + cnIntLast + cnInteger;
        return chineseStr;
      }
      //转换为字符串
      money = money.toString();
      if (money.indexOf(".") == -1) {
        integerNum = money;
        decimalNum = "";
      } else {
        parts = money.split(".");
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, 4);
      }
      //获取整型部分转换
      if (parseInt(integerNum, 10) > 0) {
        let zeroCount = 0;
        let IntLen = integerNum.length;
        for (let i = 0; i < IntLen; i++) {
          let n = integerNum.substr(i, 1);
          let p = IntLen - i - 1;
          let q = p / 4;
          let m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              chineseStr += cnNums[0];
            }
            //归零
            zeroCount = 0;
            chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            chineseStr += cnIntUnits[q];
          }
        }
        chineseStr += cnIntLast;
      }
      //小数部分
      if (decimalNum != "") {
        console.log(decimalNum);
        let decLen = decimalNum.length;
        for (let i = 0; i < decLen; i++) {
          let n = decimalNum.substr(i, 1);
          if (n != "0") {
            chineseStr += cnNums[Number(n)] + cnDecUnits[i];
          } else {
            chineseStr += "零";
          }
        }
      }
      if (chineseStr == "") {
        chineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (decimalNum == "") {
        chineseStr += cnInteger;
      }
      return chineseStr;
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      if (this.currenindex !== 3) {
        this.pagesgettableData();
      } else {
        this.gettableData();
      }
    },
    changeSizes() {
      this.tableParam.pageSize = this.curElPage;
      if (this.currenindex !== 3) {
        this.pagesgettableData();
      } else {
        this.gettableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo {
  padding: 20px 20px 0 20px;
  max-height: 400px;
  overflow: auto;
}

.tabtop {
  width: 571px;
}

.el-input,
.el-select {
  width: 240px;
}

/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.5;
}

.bill_top {
  display: flex;
  justify-content: space-between;

  .text {
    font-weight: 600;
    color: #000;
  }
}

.bill_title {
  font-size: 18px;
  font-weight: 600;
  padding: 15px 0;
}

.bill_title1 {
  font-size: 18px;
  font-weight: 600;
  padding-top: 15px;
}

.bill_subtitle {
  padding: 20px 0;

  >span {
    padding-right: 20px;
  }

  .text {
    color: #000;
  }
}

.combined {
  border: 1px solid #ebeef5;
  text-align: center;
  line-height: 40px;
}

#dyBox {
  padding: 30px;

  >div {
    border: 1px solid #ccc;
    padding: 35px;

    .top {
      >div:nth-of-type(1) {
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }

      >div:nth-of-type(2) {
        padding-top: 20px;
        padding-left: 335px;
        font-size: 14px;

        >div:nth-of-type(2) {
          margin-top: 20px;
          letter-spacing: 14px;

          >span {
            margin-left: 5px;
          }
        }

        span {
          letter-spacing: normal;
          display: inline-block;
          margin-left: 30px;
          font-size: 14px;
        }
      }

      >div:nth-of-type(3) {
        padding: 5px 0 5px 0;

        >span {
          font-size: 14px;
          width: 350px;
          display: inline-block;
        }
      }
    }

    .formBox {
      margin-top: 10px;

      >div {
        display: flex;

        >div {
          flex: 1;
          display: flex;
          margin-top: 30px;
          line-height: 10px;

          >.table {
            width: 110px;
            text-align: justify;

            span {
              display: inline-block;
              width: 100%;
            }
          }

          >span:nth-of-type(2) {
            text-align: center;
            margin-left: 5px;
            flex: 1;
            border-bottom: 1px solid #0a0a0a;
          }
        }

        >div:nth-of-type(1) {
          margin-right: 70px;
        }
      }
    }

    .tableBox {
      >div:nth-of-type(1) {
        margin-top: 70px;
        margin-bottom: 40px;
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }
    }
  }
}

#dyAllBox {
  padding: 30px;

  >div {
    border: 1px solid #ccc;
    padding: 35px;

    .top {
      >div:nth-of-type(1) {
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }

      >div:nth-of-type(2) {
        padding-top: 20px;
        padding-left: 335px;
        font-size: 14px;

        >div:nth-of-type(2) {
          margin-top: 20px;
          letter-spacing: 14px;

          >span {
            margin-left: 5px;
          }
        }

        span {
          letter-spacing: normal;
          display: inline-block;
          margin-left: 30px;
          font-size: 14px;
        }
      }

      >div:nth-of-type(3) {
        padding: 5px 0 5px 0;

        >span {
          font-size: 14px;
          width: 350px;
          display: inline-block;
        }
      }
    }

    .formBox {
      margin-top: 10px;

      >div {
        display: flex;

        >div {
          flex: 1;
          display: flex;
          margin-top: 30px;
          line-height: 10px;

          >.table {
            width: 110px;
            text-align: justify;

            span {
              display: inline-block;
              width: 100%;
            }
          }

          >span:nth-of-type(2) {
            text-align: center;
            margin-left: 5px;
            flex: 1;
            border-bottom: 1px solid #0a0a0a;
          }
        }

        >div:nth-of-type(1) {
          margin-right: 70px;
        }
      }
    }

    .tableBox {
      >div:nth-of-type(1) {
        margin-top: 70px;
        margin-bottom: 40px;
        font-size: 30px;
        font-weight: 800;
        text-align: center;
        letter-spacing: 35px;
        font-family: "LiSu";
      }
    }
  }
}
</style>

